<template>
  <div :data-idx="idx" class="card" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
    <div
      :class="[
        'box flex items-center justify-center relative card-container',
        { current: idx === current },
      ]"
    >
      <Resource
        class="img-bg"
        :src="feat.card_base_image_url"
        :transformResource="transformImage"
        alt="card_base_image_url"
      />
      <video v-if="videoPlay" class="img-gif" :src="feat.hover_video" autoplay muted />
      <div class="content">
        <XTag v-if="feat.show_new_icon" :type="'new'" size="large" class="new-tag" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { IProductHighlight } from '~/api/interface/publicize';

defineProps<{
  feat: IProductHighlight;
  idx: number;
  current: number | undefined;
  loading: boolean;
}>();

const videoPlay = ref(false);

let sid: number;

const handleMouseEnter = () => {
  if (sid) {
    window.clearTimeout(sid);
  }
  sid = window.setTimeout(() => {
    videoPlay.value = true;
  }, 300);
};

const handleMouseLeave = () => {
  window.clearTimeout(sid);
  videoPlay.value = false;
};

onBeforeUnmount(() => {
  window.clearTimeout(sid);
});

const emits = defineEmits(['load', 'enter']);
</script>

<style scoped lang="scss">
.img-gif {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  height: 100%;
  right: 14px;
  border-radius: 6.4px;
  object-fit: cover;
}

.img-bg {
  position: absolute;
  height: 100%;
  width: 100%;
}

.content {
  position: absolute;
  width: 100%;
  height: 100%;
}

.card-container {
  padding: 14px;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 50%;
  overflow: hidden;
  top: 50%;
  border-radius: 12px;
  transform: translate(-50%, -50%);
  transition: all 0.3s ease-in-out;
}

.new-tag {
  position: absolute;
  top: 12px;
  left: 12px;
}

.card {
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 56.25%;
  cursor: pointer;
  transition: all 0.6s ease-in-out;

  .go {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 20px;
    bottom: 22px;

    span,
    iconpark-icon {
      font-weight: 600;
      font-size: 12px;
      line-height: 18px;
      color: var(--primary-color);
      display: block;
      opacity: 0;
      transition: all 0.2s ease-out;
    }
    span {
      margin-right: 4px;
      transform: translate(-500%);
    }
    iconpark-icon {
      transform: translate(500%, 1px);
    }
  }

  &:hover {
    .new-tag {
      display: none;
    }
    .gif-play {
      transform: scale(1.1);
    }
    .title {
      transform: translateY(-18px);
    }
    .go {
      span,
      iconpark-icon {
        opacity: 1;
        transform: translateX(0);
      }
      iconpark-icon {
        transform: translateY(1px);
      }
    }
  }

  .box {
    width: 100%;
    height: 100%;
  }
}
</style>
